"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hoverintent = _interopRequireDefault(require("hoverintent"));

var _popover = _interopRequireDefault(require("../popover"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TRIGGER_HOVER = 'hover';
var TRIGGER_FOCUS = 'focus';
var TRIGGER_CLICK = 'click';
/**
 * A smart trigger for managing the state of a [Popover](#popover).
 *
 * If you want to manage the open-closed state of the Popover yourself,
 * use [Popover](#popover) directly.
 *
 * `respondsToClick`, `respondsToHover`, and `respondsToFocus` props determine
 * the means of opening and closing the Popover with interactions. If you open
 * the Popover with a hover or focus, you can also close it by hovering away or
 * blurring. If, however, you open the Popover with a click, you can only close
 * it with another click, on the trigger or outside the Popover. If you
 * open the Popover with a hover and *then* you click, this is equivalent to
 * opening it with a click directly, so it will only close with another
 * click (not from just hovering away).
 */

var PopoverTrigger =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PopoverTrigger, _React$Component);

  function PopoverTrigger() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PopoverTrigger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PopoverTrigger)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      visible: false,
      activeTriggerType: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openPopover", function (trigger, callback) {
      var alreadyOpen = !!_this.state.visible;

      _this.setState({
        visible: true,
        activeTriggerType: trigger
      }, function () {
        if (!alreadyOpen && _this.props.onPopoverOpen) {
          _this.props.onPopoverOpen();
        }

        if (callback) callback();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closePopover", function (callback) {
      var alreadyClosed = !_this.state.visible;

      _this.setState({
        visible: false,
        activeTriggerType: null
      }, function () {
        if (!alreadyClosed && _this.props.onPopoverClose) {
          _this.props.onPopoverClose();
        }

        if (callback) callback();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onAnyClick", function (event) {
      // If the trigger responds to focus but not click and you *first*
      // focus *then* click, that click closes the popover instead of
      // leaving it open even when the mouse moves away.
      if (!_this.props.respondsToClick && _this.state.visible && _this.state.activeTriggerType === TRIGGER_FOCUS) {
        _this.hide();

        return;
      }

      if (!_this.hoverIsBlocked && (_this.props.disabled || !_this.props.respondsToClick)) {
        return;
      } // A trigger click always takes precedence over hover or focus interactions.
      // If the popover is already open by hover or focus, a click will change its
      // priorities, so it stays open even if you mouseleave or blur


      if (_this.state.visible && _this.state.activeTriggerType === TRIGGER_CLICK && (!_this.popoverElement || !_this.popoverElement.contains(event.target))) {
        _this.hide();
      } else {
        _this.showBecauseClick();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockHover", function () {
      if (!_this.hoverIsBlocked) {
        _this.hoverIsBlocked = true;
        _this.addMouseMoveUnblockTimeout = setTimeout(function () {
          document.addEventListener('mousemove', _this.unblockHover);
        }, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unblockHover", function () {
      if (_this.hoverIsBlocked) {
        _this.hoverIsBlocked = false;
        document.removeEventListener('mousemove', _this.unblockHover);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTriggerMouseEnter", function () {
      if (_this.props.disabled || !_this.props.respondsToHover || _this.state.activeTriggerType && _this.state.activeTriggerType !== TRIGGER_HOVER || _this.hoverIsBlocked) {
        return;
      }

      _this.showBecauseHover();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTriggerMouseLeave", function (event) {
      if (_this.props.disabled || !_this.props.respondsToHover || _this.state.activeTriggerType !== TRIGGER_HOVER || _this.hoverIsBlocked) {
        return;
      } // When you hover over the popover, you do not want to disappear from beneath
      // your cursor. This keeps the popover open when your cursor is within it.


      if (!_this.popoverElement || !_this.popoverElement.contains(event.relatedTarget)) {
        _this.hideBecauseHover();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPopoverMouseLeave", function (event) {
      if (_this.props.disabled || !_this.props.respondsToHover || _this.state.activeTriggerType !== TRIGGER_HOVER || _this.hoverIsBlocked) {
        return;
      }

      if (!_this.triggerElement || !_this.triggerElement.contains(event.relatedTarget)) {
        _this.hideBecauseHover();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTriggerFocus", function () {
      if (_this.props.disabled || !_this.props.respondsToFocus || _this.state.visible || _this.triggerFocusIsBlocked) {
        return;
      }

      _this.showBecauseTriggerFocus();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTriggerBlur", function () {
      if (_this.props.disabled || !_this.props.respondsToFocus || !_this.state.visible || _this.state.activeTriggerType !== TRIGGER_FOCUS) {
        return;
      }

      _this.hide();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTriggerKeyDown", function (event) {
      var escapeCloses = _this.props.popoverProps.escapeCloses;
      if (escapeCloses === false) return;

      if (event.key === 'Escape') {
        _this.hide();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showBecauseClick", function () {
      _this.clearTimeouts();

      _this.removePopoverListeners();

      _this.openPopover(TRIGGER_CLICK);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showBecauseHover", function () {
      _this.openPopover(TRIGGER_HOVER);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showBecauseTriggerFocus", function () {
      _this.clearTimeouts();

      _this.removePopoverListeners();

      _this.openPopover(TRIGGER_FOCUS);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideBecauseHover", function () {
      _this.hide();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hide", function () {
      if (!_this.state.visible) return;

      _this.clearTimeouts();

      _this.removePopoverListeners();

      _this.closePopover(); // If focus was inside the popover, after the popover closes focus will
      // return to the trigger. We need to prevent that from re-opening the
      // trigger.


      _this.triggerFocusIsBlocked = true;
      _this.cancelTriggerFocusIsBlockedTimeout = setTimeout(function () {
        _this.triggerFocusIsBlocked = false;
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removePopoverListeners", function () {
      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          popoverElement = _assertThisInitialize.popoverElement;

      if (!popoverElement) return;
      popoverElement.removeEventListener('mouseleave', _this.onPopoverMouseLeave);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ignoreClickWithinElement", function (element) {
      if (_this.triggerElement && _this.triggerElement.contains(element)) return true;
      var ignoreClickWithinElement = _this.props.popoverProps.ignoreClickWithinElement;

      if (ignoreClickWithinElement) {
        return ignoreClickWithinElement(element);
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getAnchorElement", function () {
      var getAnchorElement = _this.props.popoverProps.getAnchorElement;

      if (getAnchorElement) {
        return getAnchorElement();
      }

      return _this.triggerElement.firstChild;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setTriggerElement", function (element) {
      _this.triggerElement = element;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPopoverElement", function (element) {
      _this.popoverElement = element;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopoverContent", function () {
      var content = _this.props.content;

      if (typeof content === 'function') {
        return content();
      } else {
        return content;
      }
    });

    return _this;
  }

  _createClass(PopoverTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.triggerElement) return;
      this.triggerElement.addEventListener('touchstart', this.blockHover);
      this.triggerElement.addEventListener('mouseout', this.onTriggerMouseLeave);
      this.hoverListener = (0, _hoverintent.default)(this.triggerElement, this.onTriggerMouseEnter, function () {});
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var popoverElement = this.popoverElement;
      var justOpened = prevState.visible === false && this.state.visible === true;

      if (justOpened && popoverElement && // If the popover was opened by hover, pay attention to hovering
      // within the popover itself
      this.state.activeTriggerType === TRIGGER_HOVER) {
        popoverElement.addEventListener('mouseleave', this.onPopoverMouseLeave);
      }

      if (!prevProps.disabled && this.props.disabled) {
        this.hide();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hoverListener.remove();
      this.triggerElement.removeEventListener('touchstart', this.blockHover);
      document.removeEventListener('mousemove', this.unblockHover);
      this.clearTimeouts();
    }
  }, {
    key: "clearTimeouts",
    value: function clearTimeouts() {
      if (this.cancelTriggerFocusIsBlockedTimeout) clearTimeout(this.cancelTriggerFocusIsBlockedTimeout);
      if (this.addMouseMoveUnblockTimeout) clearTimeout(this.addMouseMoveUnblockTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state;
      var popover = null;

      if (state.visible) {
        // Only send focus inside if we've clicked to open
        var receiveFocus = props.receiveFocus && state.activeTriggerType === TRIGGER_CLICK;
        var trapFocus = props.trapFocus && state.activeTriggerType === TRIGGER_CLICK;
        popover = _react.default.createElement(_popover.default, _extends({
          onExit: this.hide
        }, props.popoverProps, {
          getAnchorElement: this.getAnchorElement,
          ignoreClickWithinElement: this.ignoreClickWithinElement,
          receiveFocus: receiveFocus,
          trapFocus: trapFocus,
          onElement: this.setPopoverElement
        }), this.getPopoverContent());
      } // Tooltips need to the popover content to be present in the DOM
      // with the appropriate id, so aria-labelledby will work


      var hiddenContent = null;

      if (!state.visible && props.renderHiddenContent) {
        hiddenContent = _react.default.createElement("div", _extends({
          className: "hide-visually"
        }, this.props.popoverProps.passthroughProps || {}), this.getPopoverContent());
      }

      var classes = (0, _classnames.default)({
        block: props.block,
        'inline-block': !props.block
      });
      return _react.default.createElement("div", _extends({
        ref: this.setTriggerElement,
        className: classes
      }, props.passthroughTriggerProps, {
        onClick: this.onAnyClick,
        onFocus: this.onTriggerFocus,
        onBlur: this.onTriggerBlur,
        onKeyDown: this.onTriggerKeyDown
      }), props.children, hiddenContent, popover);
    }
  }]);

  return PopoverTrigger;
}(_react.default.Component);

exports.default = PopoverTrigger;
PopoverTrigger.propTypes = {
  /**
   * The trigger content. This can either be a string or valid JSX.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * If `true`, the element will be `block` displayed instead of `inline-block`.
   *
   * This is sometimes necessary to get your pixel-perfect layout.
   */
  block: _propTypes.default.bool,

  /**
   * The popover content. This can either be a string, valid JSX, or a function
   * returning either.
   */
  content: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),

  /**
   * **You will not need to use this.** This prop is used by
   * [Tooltip](#tooltip) for improved accessbility.
   *
   * If `true`, the popover will always be rendered *but it will be visually
   * hidden when inactive*.
   *
   * By default, the popover is added to and removed from the DOM dynamically.
   */
  renderHiddenContent: _propTypes.default.bool,

  /**
   * Whether or not the popover receives focus when it opens.
   *
   * This will *only* happen if the trigger is opened with a click.
   */
  receiveFocus: _propTypes.default.bool,

  /**
   * Whether or not the popover receives *and traps* focus when it opens.
   *
   * This will *only* happen if the trigger is opened with a click.
   */
  trapFocus: _propTypes.default.bool,

  /**
   * Whether or not the trigger responds to clicks.
   *
   * **Warning**: You probably don't want to use `respondsToClick` and
   * `receivesFocus` *and* `respondsToFocus` all together, because they can
   * have clashing interactions. For example, when the popover that trapped
   * focus closes, it returns focus to the trigger, which then causes the
   * popover to open again.
   */
  respondsToClick: _propTypes.default.bool,

  /**
   * Whether or not the trigger responds to `mouseenter` and `mouseleave` events.
   */
  respondsToHover: _propTypes.default.bool,

  /**
   * Whether or not the trigger responds to `focus` and `blur` events.
   */
  respondsToFocus: _propTypes.default.bool,

  /**
   * Whether or not the trigger is disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Props to pass directly to the [Popover](#popover) component. See Popover's
   * documentation for details.
   */
  popoverProps: _propTypes.default.object,

  /**
   * Props to pass directly to the `<div>` that will wrap your trigger content.
   */
  passthroughTriggerProps: _propTypes.default.object,

  /**
   * Callback that is invoked when the popover opens.
   */
  onPopoverOpen: _propTypes.default.func,

  /**
   * Callback that is invoked when the popover closes.
   */
  onPopoverClose: _propTypes.default.func
};
PopoverTrigger.defaultProps = {
  block: false,
  disabled: false,
  renderHiddenContent: false,
  receiveFocus: true,
  trapFocus: false,
  respondsToClick: true,
  respondsToHover: false,
  respondsToFocus: false,
  popoverProps: {}
};